import { forwardRef, useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';
import AppContext from './../contexts/AppContext';

const Button = forwardRef(
  (
    {
      action,
      className,
      // 'data-zuko-id': dataZukoId,
      disabled,
      isLoading,
      title,
      type,
      secondary = false,
    }: any,
    ref: any
  ) => {
    const { isDebrandedVersion } = useContext(ConfigContext);
    const { slides, currentSlide } = useContext(AppContext);

    return (
      <button
        ref={ref}
        className={`text-[17px] md:text-[18px] w-full md-max:max-w-[279px] short:!w-[350px] md:w-[400px] ${
          secondary
            ? ''
            : isDebrandedVersion
            ? ' md:hover:bg-[#5ecf7f]'
            : ' md:hover:bg-enph-orange'
        } md:hover:disabled:bg-[grey] disabled:bg-[grey] rounded-[56px] h-12 short:!h-[39px] md:h-[57px] transition-colors duration-300 ${className} ${
          secondary
            ? 'text-black bg-transparent underline'
            : 'text-white bg-black'
        }`}
        type={type || 'button'}
        onClick={action}
        disabled={disabled}
       // data-zuko-id={
        //   dataZukoId ? dataZukoId : `${slides[currentSlide]?.key}_continue`
        // }
        >
        {isLoading ? (
          <span className="loader-dots"></span>
        ) : (
          title || 'Continue'
        )}
      </button>
    );
  }
);

export default Button;
